import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import { useLocation } from "react-router-dom";


const Header = ({ forceScrolled = false }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (!forceScrolled) {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 50);
      };
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [forceScrolled]);

  const location = useLocation();
  const isCaseStudyPage = location.pathname.startsWith("/case/");
  const scrolledClass = forceScrolled || isScrolled || isCaseStudyPage ? "scrolled" : "";
  

  return (
    <header className={`header ${scrolledClass}`} style={{ zIndex: 3000 }}>
      <div className="logo-container">
      <div className="logo">
        {(scrolledClass || window.innerWidth < 1200) ? "FL" : "Felix Larsson Ljungsvik"}
        </div>
      </div>
      <div
        className="hamburger-container"
        onClick={() => setMenuOpen(!menuOpen)}
        style={{ zIndex: 3001 }}
      >
        <div className="hamburger">{menuOpen ? "×" : "☰"}</div>
      </div>

      <nav className={`menu ${menuOpen ? "open" : ""}`}>
        <ul>
          <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
          <li><Link to="/about-me" onClick={() => setMenuOpen(false)}>About Me</Link></li>
          <li>
  <a
    href="https://drive.google.com/file/d/1e540wPEIiBgox-zi0XwePUHMnEDgS0ei/view?usp=sharing"
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => setMenuOpen(false)}
  >
    CV
  </a>
</li>
        </ul>
        <p className="fine-print">© 2025 Felix Larsson Ljungsvik. All rights reserved.</p>
      </nav>
    </header>
  );
};

export default Header;
